import React from 'react';


class OStore extends React.Component {
    constructor(props) {
        super(props)

        this.state = {picLoaded: false, isLoaded: false, mode: 'init', is_narrow:false}
    }

    componentDidMount () {
        this.setState({isLoaded:true, cat:'pencil'})

    }

    mnu_click = (cat) => {
        this.setState({cat: cat})
    }



render() {
    
    let adv1 = <a href='robs_gallery.html'><img alt='' src='gal_ad.png'/></a>
    let adv2 = null
    let prod_ele_class = 'product-item'
    let prod_img_class = 'product-images'
    let prod_bound_class = 'product-boundary'

    
    // configure format and layout adjustments for small devices
    if(window.sessionStorage.getItem("device-type") === "small") {
        adv1 = null
        adv2 = <a href='contact.html'><img className='ads-boundary-2' alt='' src='placehold_ad_banner.png'/></a>
        prod_ele_class = 'product-item-mo'
        prod_img_class = 'product-images-mo'
        prod_bound_class = 'product-boundary-mo'
    }

    return (

    
    <div className='store-boundary' id='store_boundary'>
    <div className='ads-boundary-2'>
        {adv2}
    </div>
        
        <div id='marketplace_boundary' className='marketplace-boundary'>

        
        
        <div className={prod_bound_class} id='product_boundary'>
            <div className='product-row'>

                
                <a href='contact.html'>
                    <div className={prod_ele_class}>
                        <div>
                            <img alt='' className={prod_img_class} src='tech.png'/>
                        </div>
                        <div className='product-desc'>
                        Software Contracts
                        </div>
                        <div className='product-detail'>
                        Considering small or interesting projects.
                        </div>
                        
                    </div>
                </a>
                <a href='robs_gallery.html'>
                    <div className={prod_ele_class}>
                        <div>
                            <img alt='' className={prod_img_class} src='eyes.png'/>
                        </div>
                        <div className='product-desc'>
                        Portrait Commissions
                        </div>
                        <div className='product-detail'>
                        Now accepting portrait commissions.
                        </div>
                        
                    </div>
                </a>
                


            </div>
        </div>
        <div style={{width:'500px'}}></div>

        <div className='ads-boundary-1'>
            {adv1}
        </div>



    </div>

    </div>
    );
    }

}
export default OStore;